/* eslint-disable react/prop-types */
import { addCardToDecklist, promoteToCommander, removeCardFromDecklist, setViewerImage } from "../store/clipboard";
import ClipboardItem from "./ClipboardItem";
import { Fragment } from "react";
import styles from "../styles/Clipboard.module.scss";
import { useDispatch } from "react-redux";
import { v4 } from "uuid";

const ClipboardItems = ({ commander, lists, recs }) => {
  const dispatch = useDispatch();
  const commanderColorId = commander ? commander.color_identity : ["W", "U", "B", "R", "G"];
  return (
    <>
      {commander && (
        <Fragment key={v4()}>
          <div className={styles.decklistSectionHeader} key="commander">
            Commander
          </div>
          <ClipboardItem
            card={commander}
            key={commander.name}
            legal
            legal_commander
            onRemove={() => dispatch(removeCardFromDecklist(commander.name))}
            onShow={() => dispatch(setViewerImage(commander.image_uri))}
            type="commander"
          />
        </Fragment>
      )}
      {Object.values(lists)
        .filter((list) => list.cards.length > 0)
        .sort((a, b) => a.i - b.i)
        .map((list) => {
          list.cards.sort((a, b) => a.cmc - b.cmc);
          return (
            <Fragment key={list.plural}>
              <div className={styles.decklistSectionHeader}>{`${list.plural} (${list.cards.length})`}</div>
              {list.cards.map((card) => (
                <ClipboardItem
                  card={card}
                  key={card.name}
                  legal={
                    !card.color_identity ||
                    card.color_identity.filter((c) => !commanderColorId.includes(c)).length === 0
                  }
                  legal_commander={card.legal_commander}
                  onPromote={() => dispatch(promoteToCommander(card))}
                  onRemove={() => dispatch(removeCardFromDecklist(card.name))}
                  onShow={() => dispatch(setViewerImage(card.image_uri))}
                  type="card"
                />
              ))}
            </Fragment>
          );
        })}
      {recs.length > 0 && (
        <Fragment key={v4()}>
          <div className={styles.decklistSectionHeader} key="recs">
            Recs
          </div>
          {recs.map((card) => (
            <ClipboardItem
              card={card}
              key={card.name}
              legal
              legal_commander={card.legal_commander}
              onAdd={() => dispatch(addCardToDecklist(card))}
              onPromote={() => dispatch(promoteToCommander(card))}
              onShow={() => dispatch(setViewerImage(card.image))}
              type="rec"
            />
          ))}
        </Fragment>
      )}
    </>
  );
};

export default ClipboardItems;
